<div fxFlex="row" fxLayoutAlign="start center" fxLayoutGap="12px">
    <div class="av-pg-title">{{title}}</div>
    <ng-content></ng-content>
</div>
